import { useEffect } from 'react';

export function useReloadWarning() {
  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);
}
